import { render, staticRenderFns } from "./FormHeading.vue?vue&type=template&id=0ea9b243"
import script from "./FormHeading.vue?vue&type=script&lang=js"
export * from "./FormHeading.vue?vue&type=script&lang=js"
import style0 from "./FormHeading.vue?vue&type=style&index=0&id=0ea9b243&lang=scss&module=true"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./FormHeading.vue?vue&type=style&index=0&id=0ea9b243&lang=scss&module=true"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./FormHeading.vue?vue&type=style&index=0&id=0ea9b243&lang=scss&module=true")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js").rerender("0ea9b243")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea9b243')) {
      api.createRecord('0ea9b243', component.options)
    } else {
      api.reload('0ea9b243', component.options)
    }
    module.hot.accept("./FormHeading.vue?vue&type=template&id=0ea9b243", function () {
      api.rerender('0ea9b243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormHeading.vue"
export default component.exports